import {createContext} from 'react';

import {CompanyContextValues} from './CompanyProvider';

export const CompanyContext = createContext<CompanyContextValues>({} as CompanyContextValues);
